import { render, staticRenderFns } from "./stop3.vue?vue&type=template&id=06164062&scoped=true"
import script from "./stop3.vue?vue&type=script&lang=js"
export * from "./stop3.vue?vue&type=script&lang=js"
import style0 from "./stop3.vue?vue&type=style&index=0&id=06164062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06164062",
  null
  
)

export default component.exports